import createReactComponent from '../createReactComponent';
export default createReactComponent('type-italic', 'TypeItalic', [["path",{"d":"M19 3H9m6 18H5m9.5-18L10 21","key":"svg-0"}]]);